import React from 'react';
import { HStack, Heading, Stack } from '@chakra-ui/react';
import CustomDateRangePicker from '../utility/dateRangePicker';
import CustomLocationSelector from '../utility/customLocationSelector';

export const SectionHeader = ({
  title,
  showLocationSelector = false,
  dateValue,
  value,
  showDateSelector = false,
  onLocationChange,
  locationValue,
}) => {
  return (
    <Stack
      width="calc(100% - 50px)"
      direction={{ base: 'column', md: 'row' }}
      justify="space-between"
      align={{ base: 'flex-start', md: 'center' }}
      spacing={6}
      paddingBottom={4}
    >
      <Heading
        size="lg"
        fontFamily={'var(--font-family-sans) !important'}
        fontWeight={600}
        color={'var(--semantic-color-text-neutral-strongest-none)'}
      >
        {title}
      </Heading>

      <HStack spacing={6}>
        {showLocationSelector && (
          <CustomLocationSelector
            locationValue={locationValue}
            setLocation={onLocationChange}
          />
        )}
        {/* This might be used in the future when we have a custom date range selector form UDS */}
        {/* {showPeriodSwitch && (
          <FormControl display="flex" alignItems="center" maxWidth="150px">
            <FormLabel htmlFor="period-switch" mb="0">
              By period
            </FormLabel>
            <Switch
              id="period-switch"
              checked={periodEnabled}
              onChange={onPeriodToggle}
            />
          </FormControl>
        )} */}
        {showDateSelector && (
          <CustomDateRangePicker dateValue={dateValue} value={value} />
        )}
      </HStack>
    </Stack>
  );
};
